import { render, staticRenderFns } from "./ChitchatDetail.vue?vue&type=template&id=1e0bc32c&scoped=true&"
import script from "./ChitchatDetail.vue?vue&type=script&lang=js&"
export * from "./ChitchatDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChitchatDetail.vue?vue&type=style&index=0&id=1e0bc32c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0bc32c",
  null
  
)

export default component.exports